import React from 'react'

function Propertyvideo() {
  return (
    // <!-- Start Video Area -->
    <div class="video-area bgImageParallax mx-auto">
        <div class="container">
            <div class="video-wrap-content" data-cues="slideInUp">
                <a data-fslightbox="video" class="video-btn text-decoration-none" href="https://youtu.be/4jnzf1yj48M?si=n9LW7Ae_YExnIMDr">
                        Play Video
                    </a>
            </div>
        </div>
    </div>
    // <!-- End Video Area -->

  )
}

export default Propertyvideo